/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AccountPolicyConfigurationBatchResponse {
    getFixupPrototypeFunction() { return AccountPolicyConfigurationBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<AccountPolicyConfigurationBatchResponse>): AccountPolicyConfigurationBatchResponse {
        let obj = Object.assign(new AccountPolicyConfigurationBatchResponse(), model);
        AccountPolicyConfigurationBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AccountPolicyConfigurationBatchResponse>): AccountPolicyConfigurationBatchResponse {
        if (!model) return null;
        return AccountPolicyConfigurationBatchResponse.newInstance(<AccountPolicyConfigurationBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AccountPolicyConfigurationBatchResponse) {
        if (!obj) return;

        models.AccountPolicyConfigurationBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AccountPolicyConfigurationBatchResponse): boolean {
        Object.setPrototypeOf(obj, AccountPolicyConfigurationBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.PolicyParameterConfiguration.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.PolicyParameterConfiguration; };

}
